import { render, staticRenderFns } from "./detailsActive.vue?vue&type=template&id=4b53b468&scoped=true&"
import script from "./detailsActive.vue?vue&type=script&lang=js&"
export * from "./detailsActive.vue?vue&type=script&lang=js&"
import style0 from "./detailsActive.vue?vue&type=style&index=0&id=4b53b468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b53b468",
  null
  
)

export default component.exports